import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ApplicationRoleCode,
    IIssueResponseBase,
    ILocationResponse,
    IssueStatusType,
    LocationSubscriptionServiceType,
} from '@kcftech/prometheustypescriptapiclient';
import { useRouteLocation } from 'contexts/RouteEntityContext';
import styled from 'styled-components';

const IconWrapper = styled.span<{ $size: number }>`
    display: flex;
    align-items: center;
    font-size: ${(props) => props.$size}rem;
`;

export type SentryValidatedIndicatorProps = Readonly<{
    issue: IIssueResponseBase;
    /** Font size in rem units. Defaults to 1.4rem */
    size?: number;
}>;

export function SentryValidatedIndicator({
    issue,
    size = 1.4,
}: SentryValidatedIndicatorProps) {
    const { location } = useRouteLocation();

    if (!isValidatedBySentry(issue, location)) {
        return null;
    }

    return (
        <IconWrapper
            $size={size}
            title="Validated by SENTRYservices"
            aria-label="Validated by SENTRYservices"
        >
            <FontAwesomeIcon icon={faShieldCheck} color="var(--icon-positive)" />
        </IconWrapper>
    );
}

export function isValidatedBySentry(
    issue: IIssueResponseBase,
    location: ILocationResponse
): boolean {
    const isPublished = issue.IssueStatus.StatusType !== IssueStatusType.Draft;

    const createdBySentry =
        issue.CreatedBy?.ApplicationRole === ApplicationRoleCode.Sentry;

    const publishedBySentry =
        issue.PublishedBy?.ApplicationRole === ApplicationRoleCode.Sentry;

    const hasSentrySubscription =
        location.Settings.SubscriptionService ===
            LocationSubscriptionServiceType.Sentry ||
        location.Settings.SubscriptionService ===
            LocationSubscriptionServiceType.DeskPlus;

    return isPublished && hasSentrySubscription && (createdBySentry || publishedBySentry);
}
